import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  ON_DENOMINATION_LIST
} from "./../constants/ActionTypes";
import {adminAPI} from 'util/Api';

export const getDenominations = ()=>{
  let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };
  return (dispatch) => {
    dispatch({type: FETCH_START});
    adminAPI.get('denomination',_data,
    ).then(({data}) => { 
      //console.log('Success');
      //console.log("Fetched Consignments: ", data);
      if (data.length) {
        dispatch({type: FETCH_SUCCESS});
        // format data and store them for use..
        dispatch({type: ON_DENOMINATION_LIST, payload: data});
      } else {
        dispatch({type: FETCH_ERROR, payload: data.error});
      }
    }).catch(function (error) {
     // console.log('Not executing this one', error);
      dispatch({type: FETCH_ERROR, payload: error.message});
     // console.log("Error****:", error.message);
    });
  }
}